import dayjs from "dayjs";

import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/de';

import i18n from './index';

dayjs.locale(i18n.language);

i18n.on('languageChanged', (lang) => {
  dayjs.locale(lang);
});
